// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"qf","text":"qh","subText":"qi","toggleContainer":"qj","checked":"qk"};